export const DEFAULT_STATE = {
    carrierPortaloriginSearchList:{},
    carrierPortaldestinationSearchList:{},
    equipmentTypeListDisplayList :{},
    carrierPortalSearchResult : {}
}